import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import actions from './actions'
import VuexPersistence from 'vuex-persist'

Vue.use(Vuex)

const vuexLocal = new VuexPersistence({
  storage: window.localStorage
})

const state = {
  user: {},
  identity: {
    id: "",
    name: "",
    lang: "fr",
    email: "",
    favorites: {
      rules: [],
      substances: []
    },
    company: "",
  },
  tmp: {
    rulesFav: [],
    needSaveRules: false,
    importDefaultRulesFav: false
  },
  url: "",
  changes: [],
  lastPage: { name: "", params: {} },
  multiRulesSelection: [],
  currentPage: { name: "", params: {} },
}

// recupération des valeurs
const getters = {
  identity: (state) => {
    return state.identity;
  },
  subs_fav: (state) => {
    return state.identity.favorites.substances;
  },
  rules_fav: (state) => {
    return state.identity.favorites.rules;
  },
  current_rules_fav: (state) => {
    return state.tmp.rulesFav;
  },
  need_save_rules: (state) => {
    return state.tmp.needSaveRules
  },
  import_Default_Rules_Fav: (state) => {
    return state.tmp.importDefaultRulesFav
  },
  user: (state) => {
    return state.user;
  },
  url: (state) => {
    return state.url;
  },
  changes: (state) => {
    return state.changes;
  },
  lastPage: (state) => {
    return state.lastPage;
  },
  multiRulesSelection: (state) => {
    return state.multiRulesSelection;
  },
  currentPage: (state) => {
    return state.currentPage;
  },
}

let store = new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
  plugins: [vuexLocal.plugin]
})

export default store;
